<template>
  <!-- 比例跟 home.jpg(1125×1386) 一致：任意屏宽都按宽缩放，cover 只裁上下不裁左右 -->
  <div
    class="relative w-full overflow-hidden aspect-[1125/1386] after:pointer-events-none after:absolute after:inset-x-0 after:bottom-0 after:z-[1] after:h-6 after:bg-gradient-to-b after:from-white/0 after:to-white/35 after:content-['']"
  >
    <JcImg
      ref="elRef"
      class="absolute inset-0 z-0 m-0 block size-full p-0 pointer-events-none select-none object-cover object-[center_28%] [-webkit-user-drag:none]"
      :level="3"
      :src="BANNER_SRC"
      alt="首页横幅"
      :loading="loading"
      :fetchpriority="fetchPriority"
    />

    <div class="relative z-[2] px-4 pt-[60px]">
      <div class="min-h-9">
        <span
          class="h-9 cursor-pointer font-popB text-[23px] font-black leading-7 text-white [text-shadow:0_0_11px_rgb(0_0_0_/_0.25)]"
          @click="joinUsBanner('H5首页Banner-主标题')"
        >
          {{ getCnOrEn(`链全球商机 帮货代盈利`, `Real Service Real Business`) }}
        </span>
      </div>
      <div class="mb-6 h-6">
        <span
          class="h-6 cursor-pointer font-popR text-base font-normal leading-[19px] text-left text-white"
          @click="joinUsBanner('H5首页Banner-副标题')"
        >
          {{
            getCnOrEn(
              `全球领先的国际物流B2B平台`,
              `The leading platform of freight forwarders`,
            )
          }}
        </span>
      </div>
      <div
        class="inline-flex h-11 w-[180px] cursor-pointer items-center justify-center rounded border border-white bg-white font-popSB text-sm font-semibold text-[#232324]"
        @click="joinUsBanner('H5首页Banner-加入会员')"
      >
        {{ getCnOrEn('加入会员', 'Become a member') }}
        <i class="iconfont icon-a-right_line2" />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { go2JoinUs } from '~/utils/auth'

  const { elRef, loading, fetchPriority } = useViewportImageLoading({
    forceEager: true,
    fetchPriority: 'high',
  })

  // JcImg level=3 入参用原图；页面实际请求的是 transform 后的 webp
  const BANNER_SRC =
    'https://resources.jctrans.com/res/era-h5/h5/img/home.jpg'
  const BANNER_PRELOAD =
    'https://assetsz.jctrans.com/transform/res/era-h5/h5/img/home.webp'

  useHead({
    link: [
      {
        key: 'preload-home-banner',
        rel: 'preload',
        as: 'image',
        href: BANNER_PRELOAD,
        type: 'image/webp',
        fetchpriority: 'high',
      },
    ],
  })

  const joinUsBanner = (entry: string) => {
    go2JoinUs(
      undefined,
      undefined,
      'PLT.REG.H5.H5_ERA_HOME_BANNER',
      'PLT.APPLI.APPLY.H5_ERA_HOME_BANNER_FORM',
      entry,
      {
        text: 'H5首页Banner',
      },
    )
  }
</script>
